/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const scan = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 8H4m6.875 5.749h2.27a.604.604 0 0 0 .604-.604v-2.27m-2.874-8.624h2.27a.604.604 0 0 1 .604.604v2.27M5.126 2.251h-2.27a.604.604 0 0 0-.604.604v2.27m2.874 8.624h-2.27a.604.604 0 0 1-.604-.604v-2.27"
    />
  </svg>
)
export default scan
